import {getWhiteLabelWorkflows, isRunningOnKlevereDomain} from '../../../white-label/permission'
import i18n from '../../../i18n'

interface Workflow {
  uuid: string
  name: string
  frontend_url: string
  backend_url: string
}

const targetLang = localStorage.getItem('app_language') || 'en'
i18n.changeLanguage(targetLang)

export const workflows: {[key: string]: Workflow[]} = {
  hr_templates: [
    {
      uuid: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
      name: i18n.t('workflow_names.job_description'),
      frontend_url: 'job-description',
      backend_url: 'generateJobDescription',
    },
    {
      uuid: '6ba7b810-9dad-11d1-80b4-00c04fd430c8',
      name: i18n.t('workflow_names.hiring_research'),
      frontend_url: 'hiring-research',
      backend_url: 'generateHiringResearch',
    },
    {
      uuid: '550e8400-e29b-41d4-a716-446655440000',
      name: i18n.t('workflow_names.performance_evaluation'),
      frontend_url: 'performance',
      backend_url: 'generatePerformanceEvaluation',
    },
    {
      uuid: '123e4567-e89b-12d3-a456-426614174000',
      name: i18n.t('workflow_names.hr_policy_design'),
      frontend_url: 'policy',
      backend_url: 'generatePolicyDesign',
    },
    {
      uuid: 'f81d4fae-7dec-11d0-a765-00a0c91e6bf6',
      name: i18n.t('workflow_names.hire_letter'),
      frontend_url: 'hire-letter',
      backend_url: 'generateHireLetter',
    },
    {
      uuid: '9c6d8c5d-6d7d-4e3a-9e1d-5b3f1c2a0b4e',
      name: i18n.t('workflow_names.termination_letter'),
      frontend_url: 'termination-letter',
      backend_url: 'generateTerminationLetter',
    },
    {
      uuid: '1b671a64-40d5-491e-99b0-da01ff1f3341',
      name: i18n.t('workflow_names.recruitment_strategy'),
      frontend_url: 'recruit-strategy',
      backend_url: 'generateRecruitmentStrategy',
    },
    {
      uuid: '2c39b876-5a41-4d6f-9b7a-7c0b5f6d3a9e',
      name: i18n.t('workflow_names.cv_screening'),
      frontend_url: 'screen-custom',
      backend_url: 'generateCvScreening',
    },
    {
      uuid: '5e228958-4d45-4f8b-8d32-7a3a4f1b5c9d',
      name: i18n.t('workflow_names.screen_linkedin_profile'),
      frontend_url: 'description-comparer-custom',
      backend_url: 'generateLinkedinScreening',
    },
  ],
  marketing_templates: [
    {
      uuid: '550e8400-e29b-41d4-a716-446655440001',
      name: i18n.t('workflow_names.blog_article'),
      frontend_url: 'blog-article',
      backend_url: 'generateBlogArticle',
    },
    {
      uuid: 'f47ac10b-58cc-4372-a567-0e02b2c3d472',
      name: i18n.t('workflow_names.website_headline'),
      frontend_url: 'website-headline',
      backend_url: 'generateWebHeadline',
    },
    {
      uuid: '6ba7b810-9dad-11d1-80b4-00c04fd430c9',
      name: i18n.t('workflow_names.digital_advertising'),
      frontend_url: 'advertising',
      backend_url: 'generateDigitalAd',
    },
    {
      uuid: '123e4567-e89b-12d3-a456-426614174001',
      name: i18n.t('workflow_names.product_descriptions'),
      frontend_url: 'prod-description',
      backend_url: 'generateProductDescription',
    },
    {
      uuid: 'f81d4fae-7dec-11d0-a765-00a0c91e6bf7',
      name: i18n.t('workflow_names.marketplace_listing'),
      frontend_url: 'marketplace-prod-description',
      backend_url: 'generateMarketProductDescription',
    },
    {
      uuid: '9c6d8c5d-6d7d-4e3a-9e1d-5b3f1c2a0b4f',
      name: i18n.t('workflow_names.social_media_post'),
      frontend_url: 'social',
      backend_url: 'generateSocialMediaPost',
    },
    {
      uuid: '1b671a64-40d5-491e-99b0-da01ff1f3342',
      name: i18n.t('workflow_names.newsletter'),
      frontend_url: 'newsletter',
      backend_url: 'generateNewsletterPost',
    },
    {
      uuid: '2c39b876-5a41-4d6f-9b7a-7c0b5f6d3a9f',
      name: i18n.t('workflow_names.press_release'),
      frontend_url: 'press-release',
      backend_url: 'generatePressRelease',
    },
    {
      uuid: '5e228958-4d45-4f8b-8d32-7a3a4f1b5c9e',
      name: i18n.t('workflow_names.image_to_social_media_caption'),
      frontend_url: 'media-caption-custom',
      backend_url: 'generateVisualSocialMediaCaption',
    },
    {
      uuid: '7c9e6679-7425-40de-944b-e07fc1f90ae7',
      name: i18n.t('workflow_names.image_to_product_description'),
      frontend_url: 'visual-prod-description-custom',
      backend_url: 'generateVisualProductDescription',
    },
    {
      uuid: '3f333df6-90a4-4ec1-9d70-0d52a594d55b',
      name: i18n.t('workflow_names.image_to_marketplace_listing'),
      frontend_url: 'generateVisualMarketplaceProductDescription',
      backend_url: 'generateVisualMarketplaceProductDescription',
    },
    {
      uuid: 'a0b1c2d3-e4f5-6789-0abc-def123456789',
      name: i18n.t('workflow_names.compare_webpages'),
      frontend_url: 'compare-webpages',
      backend_url: 'generateCompareWebPages',
    },
    {
      uuid: 'b1c2d3e4-f5a6-7b89-0cde-f123456789ab',
      name: i18n.t('workflow_names.youtube_video_to_blog'),
      frontend_url: 'youtube-custom',
      backend_url: 'generateBlogFromYoutube',
    },
    {
      uuid: 'c2d3e4f5-6a7b-8c90-1def-23456789abcd',
      name: i18n.t('workflow_names.feedback_to_webpage'),
      frontend_url: 'webpage-feedback',
      backend_url: 'generateWebsiteFeedback',
    },
  ],
  sales_templates: [
    {
      uuid: '9a7b8c6d-4e5f-4a3b-8c2d-1f3e4a5b6c7d',
      name: i18n.t('workflow_names.subject_lines'),
      frontend_url: 'subject-lines',
      backend_url: 'generateSubjectLines',
    },
    {
      uuid: '18e9f8d7-c6b5-4a3d-8e2f-1d3c4b5a6e7f',
      name: i18n.t('workflow_names.sales_proposals'),
      frontend_url: 'sales-proposals',
      backend_url: 'generateSalesProposal',
    },
    {
      uuid: '3a2b1c4d-5e6f-7a8b-9c0d-1e2f3a4b5c6d',
      name: i18n.t('workflow_names.generate_cold_email'),
      frontend_url: 'cold-emails',
      backend_url: 'generateColdEmail',
    },
    {
      uuid: '5f4e3d2c-1b0a-9f8e-7d6c-5b4a3f2e1d0c',
      name: i18n.t('workflow_names.ice_breaker_for_cold_outreach'),
      frontend_url: 'ice-breaker',
      backend_url: 'generateIceBreaker',
    },
    {
      uuid: '2d3e4f5a-6b7c-8d9e-0f1a-2b3c4d5e6f7a',
      name: i18n.t('workflow_names.personalize_linkedin_requests'),
      frontend_url: 'linkedin-requests',
      backend_url: 'generateLinkedinRequest',
    },
    {
      uuid: '10a9b8c7-d6e5-f4a3-b2c1-d0e9f8a7b6c5',
      name: i18n.t('workflow_names.three_key_benefits'),
      frontend_url: 'linkedin-key-benefits',
      backend_url: 'generateThreeKeyBenefits',
    },
    {
      uuid: '6a5b4c3d-2e1f-0a9b-8c7d-6e5f4a3b2c1d',
      name: i18n.t('workflow_names.resource_finder'),
      frontend_url: 'resource-finder',
      backend_url: 'generateResourceFinder',
    },
    {
      uuid: '7b6c5d4e-3f2a-1b0c-9d8e-7f6a5b4c3d2e',
      name: i18n.t('workflow_names.industry_research'),
      frontend_url: 'industry-research',
      backend_url: 'generateIndustryResearch',
    },
    {
      uuid: '7b6c5d4e-3f2a-1b0c-9d8e-7f6a5b4c3d2g',
      name: i18n.t('workflow_names.company_research_with_website'),
      frontend_url: 'company-research',
      backend_url: 'generateCompanyResearchWithWebsite',
    },
    {
      uuid: '8c7d6e5f-4a3b-2c1d-0e9f-8a7b6c5d4e3f',
      name: i18n.t('workflow_names.company_research_with_linkedin'),
      frontend_url: 'company-research-linkedin',
      backend_url: 'generateCompanyLinkedinResearch',
    },
    {
      uuid: '8c7d6e5f-4a3b-2c1d-0e9f-8a7b6c5d4e3y',
      name: i18n.t('workflow_names.pain_point_email'),
      frontend_url: 'pain-point-email',
      backend_url: 'generatePainpointEmail',
    },
  ],
}

export function getWorkflows(language?: string): Workflow[] {
  //  const targetLang = language || localStorage.getItem('appLanguage') || 'en';

  //   if (i18n.language !== targetLang) {
  //     localStorage.setItem('appLanguage', targetLang);
  //   }

  const data = Object.values(workflows).flat()

  if (!isRunningOnKlevereDomain()) {
    const whiteLabelWorkflows = getWhiteLabelWorkflows()

    if (whiteLabelWorkflows) {
      const filteredData = data.filter((workflow) => whiteLabelWorkflows.includes(workflow.uuid))
      return filteredData
    }
  }

  return data
}

// Search by UUID
export function findWorkflowByUuid(uuid: string): Workflow | undefined {
  for (const category in workflows) {
    const found = workflows[category].find((workflow) => workflow.uuid === uuid)
    if (found) {
      return found
    }
  }
  return undefined
}

// Search by Name
export function findWorkflowByName(name: string): Workflow | undefined {
  for (const category in workflows) {
    const found = workflows[category].find((workflow) => workflow.name === name)
    if (found) {
      return found
    }
  }
  return undefined
}

// Search by Frontend URL
export function findWorkflowByFrontendUrl(frontend_url: string): Workflow | undefined {
  for (const category in workflows) {
    const found = workflows[category].find((workflow) => workflow.frontend_url === frontend_url)
    if (found) {
      return found
    }
  }
  return undefined
}

// Search by Backend URL
export function findWorkflowByBackendUrl(backend_url: string): Workflow | undefined {
  for (const category in workflows) {
    const found = workflows[category].find((workflow) => workflow.backend_url === backend_url)
    if (found) {
      return found
    }
  }
  return undefined
}
